import { trackEvent, useTrackLink } from '@99designs/tracking';
import { ProductLandingGroupKey } from './productLandingGroups';
import { VPProductLandingGroupKey } from './vpProductLandingGroups';

export type trackCTAClickedParams = {
    category: ProductLandingGroupKey | VPProductLandingGroupKey;
    ctaLocation: string;
    ctaButton: string;
};

export const trackCTAClicked = ({ category, ctaLocation, ctaButton }: trackCTAClickedParams) => {
    trackEvent('Clicked CTA on Product page', {
        category,
        cta_location: ctaLocation,
        cta_button: ctaButton,
    });
};

export const useTrackCTALinkClicked = ({
    category,
    ctaLocation,
    ctaButton,
}: trackCTAClickedParams) => {
    return useTrackLink(
        {
            event: 'Clicked CTA on Product page',
            meta: {
                category,
                cta_location: ctaLocation,
                cta_button: ctaButton,
            },
        },
        []
    );
};
